import script from "./InitialEvalReferralTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./InitialEvalReferralTable.vue?vue&type=script&setup=true&lang=ts"

import "./InitialEvalReferralTable.vue?vue&type=style&index=0&id=300e48dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-300e48dc"]])

export default __exports__